module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi44ODYiIGhlaWdodD0iMjQuMDYiIHZpZXdCb3g9IjAgMCAxMi44ODYgMjQuMDYiPgogIDxwYXRoIGlkPSJJY29uX2F3ZXNvbWUtZmFjZWJvb2stZiIgZGF0YS1uYW1lPSJJY29uIGF3ZXNvbWUtZmFjZWJvb2stZiIgZD0iTTEzLjY1MSwxMy41MzQsMTQuMzIsOS4xOEgxMC4xNDJWNi4zNTRBMi4xNzcsMi4xNzcsMCwwLDEsMTIuNiw0aDEuOVYuMjk0QTIzLjE2NCwyMy4xNjQsMCwwLDAsMTEuMTI0LDBjLTMuNDQxLDAtNS42OSwyLjA4Ni01LjY5LDUuODYxVjkuMThIMS42MDl2NC4zNTRINS40MzRWMjQuMDZoNC43MDdWMTMuNTM0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNjA5KSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_facebook.svg
// module id = djBh
// module chunks = 1